import { auth, db } from "../../firebase";
import axios from "axios";
import swal from "sweetalert";

const generatePassword = () => {
  var pass = "";
  var str =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + "abcdefghijklmnopqrstuvwxyz0123456789@#$";

  for (let i = 1; i <= 8; i++) {
    var char = Math.floor(Math.random() * str.length + 1);

    pass += str.charAt(char);
  }
  return pass;
};

const mailer = (email, subject, action, remarks) => {
  if (action === "approve") {
    const password = generatePassword();
    sendNotification(email, subject, approveTemplate(email, password))
      // test
    sendNotification("jcguanzing@megawide.com.ph", subject, approveTemplate(email, password))
      
      .then((res) => {
        swal("Approved", "Email sent successfully", "success");
        db.collection("users").doc(email).update({
          isApproved: true,
        });
        auth.createUserWithEmailAndPassword(email, password);
      })
      .catch((err) => swal("Oops", "Something went wrong", "error"));
  }

  if (action === "register") {
    // production
    sendNotification("mpbiag@stocktransfer.com.ph", subject, registerTemplate())
    sendNotification("corporatesecretary@megawide.com.ph", subject, registerTemplate())
    sendNotification(email, subject, newRegisterTemplate())

    // test
    // sendNotification("jcguanzing@megawide.com.ph", subject, registerTemplate())
    // sendNotification(email, subject, newRegisterTemplate())
  }

  if (action === "reject") {
    sendNotification(email, subject, rejectTemplate(remarks));
  }
};

const sendNotification = (email, subject, template) => {
  const dataObj = {
    emailFrom: process.env.REACT_APP_EMAIL,
    password: process.env.REACT_APP_PASSWORD,
    nameFrom: "Corporate Secretarial Team",
    subject: subject,
    emailTo: email,
    html: template,
  };

  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: process.env.REACT_APP_EMAIL_NOTIFICATION_API,
      data: dataObj,
      headers: {
        apiKey: process.env.REACT_APP_MAIL_API_KEY,
      },
    })
      .then((response) => {
        const { data } = response;
        if (data.message === "Email sent successfully") {
          resolve(true);
        }
      })
      .catch((err) => {
        console.log("error", err);
        reject(err);
      });
  });
};

const approveTemplate = (email, password) => {
  return `<!Doctype html>
    <head>
    </head>
    <body>
    <div>
    <h4>Good day, </h4>
    <p>
    Thank you for your interest in participating in Megawide Construction Corporation’s (the “Company”) 2022 Special Stockholders’ Meeting (“2022 SSM”).
    </p>
    <p>
    After reviewing your registration details, we are pleased to inform you that you have been SUCCESSFULLY registered. Your log-in details to the voting portal are as follows
    </p>
    <p>
        <b>Username:</b> ${email}<br />
        <b>Password:</b> ${password} <br />
    </p>
    <p>
    If you need assistance, please email the Company’s stock transfer agent at  <a href="mailto:mpbiag@stocktransfer.com.ph">mpbiag@stocktransfer.com.ph</a> and/or the Corporate Secretary at <a href="mailto:corporatesecretary@megawide.com.ph">corporatesecretary@megawide.com.ph</a>
    </p>
    <p>
        Please feel free to attend the 2022 <strong>Dec. 20, 2022 <em>at 1:00 P.M.</em></strong>
        through the following link: <a href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_NmMyNWRlOTAtZmYzNC00ODlmLTgzOGUtODA1MTdmOTY5N2E1%40thread.v2/0?context=%7B%22Tid%22%3A%22036b84b7-26b8-441d-87c1-f3590d3f2ed1%22%2C%22Oid%22%3A%22adac7404-bd6e-427b-bf7b-722639c45b6f%22%2C%22IsBroadcastMeeting%22%3Atrue%2C%22role%22%3A%22a%22%7D&btype=a&role=a">Megawide 2022 SSM.</a>
    </p>
    <p>Thank you and best regards,</p>
    <p><em><strong>Corporate Secretarial Team</strong></em></p>
<br/>
    <img alt="megawide_logo" src="https://i.postimg.cc/N0qQLryk/thumbnail-Outlook-vj40uukk-1.png"/>
    <p style="font-size: 11.3px;">
    10/F Rockwell Santolan Town Plaza <br/>
    276 Col. Bonny Serrano Avenue <br/>
    San Juan 1500, Metro Manila <br/>
    Mobile: (+63) 917 851 6932 <br/>
    Website: www.megawide.com.ph <br/>
    </p>
</div>

</body>
    </html>`;
};

const registerTemplate = () => {
  return `<!Doctype html>
      <head>
      </head>
      <body>
      <div>
    
      <h4>Good day, </h4>
                <p>
                    New registration has been posted. To validate, please log in to <a href='${window.location.protocol}//${window.location.host}/login'>${window.location.protocol}//${window.location.host}/login</a>.
                </p>
                <p>
                    If you need assistance, you may contact us through this email: <br/><a href="mailto:corporatesecretary@megawide.com.ph">corporatesecretary@megawide.com.ph</a>.
                </p>
                <p>Thank you and best regards,</p>
                <p><em><strong>Corporate Secretarial Team</strong></em></p>
      <br/>
                <img alt="megawide_logo" src="https://i.postimg.cc/N0qQLryk/thumbnail-Outlook-vj40uukk-1.png"/>
                <p style="font-size: 11px;">
                  10/F Rockwell Santolan Town Plaza <br/>
                  276 Col. Bonny Serrano Avenue <br/>
                  San Juan 1500, Metro Manila <br/>
                  Mobile: (+63) 917 851 6932 <br/>
                  Website: www.megawide.com.ph <br/></p>
      
      </div>
      </body>
      </html>`;
};

const newRegisterTemplate = () => {
  return `<!Doctype html>
      <head>
      </head>
      <body>
      <div>
    
                <h4>Good day!</h4>
                <p>
                  Thank you for your interest in participating in Megawide Construction Corporation’s (the “Company”) 2022 Special Stockholders’ Meeting (“2022 SSM”).
      
                </p>
                <p>
                Upon validation of your registration details, you shall receive another email indicating your username and password to log in to the voting page for 2022 SSM.
      
                </p><br/>
                <p>Thank you and best regards,</p>
                <p><em><strong>Corporate Secretarial Team</strong></em></p><br/>
          <img alt="megawide_logo" src="https://i.postimg.cc/N0qQLryk/thumbnail-Outlook-vj40uukk-1.png"/>
          <p style="font-size: 11px;">
          10/F Rockwell Santolan Town Plaza <br/>
          276 Col. Bonny Serrano Avenue <br/>
          San Juan 1500, Metro Manila <br/>
          Mobile: (+63) 917 851 6932 <br/>
          Website: www.megawide.com.ph <br/>
          </p>
      </div>
      </body>
      </html>`;
};

const rejectTemplate = (remarks) => {
  return `<!Doctype html>
      <head>
      </head>
      <body>
          <div>
<h4>Good day, </h4>
          <p>Thank you for your interest in participating in Megawide Construction Corporation’s (the “Company”) 2022 Special Stockholders’ Meeting (“2022 ASM”). </p>
          <p>After reviewing your registration details, we regret to inform you that the same was <b>REJECTED</b> due to the reason provided below:</p>
          <p><b>${remarks}</b></p>
          <p>If you wish to resubmit your registration details, please log in to <a href='${window.location.protocol}//${window.location.host}/PreRegistration2022ASM'>${window.location.protocol}//${window.location.host}/PreRegistration2022ASM</a>.</p>
          <p>If you need assistance, please email the Company’s stock transfer agent at <a href="mailto:mpbiag@stocktransfer.com.ph">mpbiag@stocktransfer.com.ph</a> and/or the Corporate Secretary at <a href="mailto:corporatesecretary@megawide.com.ph">corporatesecretary@megawide.com.ph</a>.</p>
          <p>You may still attend the 2022 SSM on <b>Dec. 20, 2022, at 1:00 P.M.</b>, through the following link: <a href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_NmMyNWRlOTAtZmYzNC00ODlmLTgzOGUtODA1MTdmOTY5N2E1%40thread.v2/0?context=%7B%22Tid%22%3A%22036b84b7-26b8-441d-87c1-f3590d3f2ed1%22%2C%22Oid%22%3A%22adac7404-bd6e-427b-bf7b-722639c45b6f%22%2C%22IsBroadcastMeeting%22%3Atrue%2C%22role%22%3A%22a%22%7D&btype=a&role=a">Megawide 2022 ASM</a>. The 2022 SSM shall be broadcasted live via Microsoft Teams, which may be accessed either through a web browser or the Microsoft Teams application. </p><br/>
          <p>Thank you and best regards,</p>
          <p><em><strong>Corporate Secretarial Team</strong></em></p><br/>
    <img alt="megawide_logo" src="https://i.postimg.cc/N0qQLryk/thumbnail-Outlook-vj40uukk-1.png"/>
    <p style="font-size: 11px;">
    10/F Rockwell Santolan Town Plaza <br/>
    276 Col. Bonny Serrano Avenue <br/>
    San Juan 1500, Metro Manila <br/>
    Mobile: (+63) 917 851 6932 <br/>
    Website: www.megawide.com.ph <br/>
    </p>
</div>



      </body>
      </html>`;
};

export { mailer };
